import React,{useContext} from 'react'
import NavbarUpper from './NavUpper'
import Navbar from './Navbar'
import { MyContext } from "../../context/MyContext";
const NavbarParent = () => {
    const { MLMStatus, verifyMlmUser } =
      useContext(MyContext);

  return (
    <div className='fixed w-[100%] z-50'>
    {verifyMlmUser?"":<NavbarUpper/>}
    <Navbar/>
    </div>
  )
}

export default NavbarParent
